
const fontSizeScale = 1.2

export default {
  name: "RichText",
  props: {
    module: Object
  },
  computed: {
    content() {
      return this.resetContent(this.module?.data?.content)
    }
  },
  mounted() {},
  methods: {
    resetContent(content) {
      const regex = /font-size:\s*(\d+)pt;/g
      return content
        .replace(regex, (match, fontSize) => {
          const newFontSize = Math.round(fontSize * fontSizeScale)
          return `font-size: ${newFontSize}pt;`
        })
        .replace(/font-family\s*:\s*[^;]*;?/g, "")
        .replace(/(face="[^"]*")/gi, "")
    }
  }
}
